import React, { useEffect } from 'react';
import ClinicInfo from '../components/clinic/ClinicInfo';
import ClinicSetting from '../components/clinic/ClinicSetting';
import ClinicTiming from '../components/clinic/ClinicTiming';
import Services from '../components/clinic/Services';
import ClinicLink from '../components/clinic/ClinicLink';
import CmsPage from '../components/clinic/CmsPage';
import Facilities from '../components/clinic/Facilities';

import { Box, Container, Grid, Divider } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getClinicProfileByIdRequest } from 'src/modules/onBoarding/store/publicActions';

const ClinicProfileLandingPage = () => {
  const dispatch = useDispatch();
  const { clinicId } = useParams();

  useEffect(() => {
    if (clinicId) {
      dispatch(getClinicProfileByIdRequest(clinicId));
    }
  }, [clinicId, dispatch]);

  const clinicProfile = useSelector(
    (state) => state.public.getClinicProfileById?.payload?.data
  );

  if (!clinicProfile) return <div>Loading...</div>;

  return (
    <Container maxWidth="lg">
      <Box>
        <Box>
          <ClinicInfo data={clinicProfile?.clinicInfo} />
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <ClinicSetting data={clinicProfile?.clinicSetting} />
          </Grid>
          <Grid item xs={12} md={4}>
            <ClinicTiming data={clinicProfile?.clinicTiming} />
          </Grid>
        </Grid>

        <Box my={2}><Divider /></Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Facilities data={clinicProfile?.facilities} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Services data={clinicProfile?.services} />
          </Grid>
        </Grid>

        <Box my={2}><Divider /></Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <ClinicLink data={clinicProfile?.clinicLink} />
          </Grid>
          <Grid item xs={12} md={6}>
            <CmsPage data={clinicProfile?.cmsPage || []} />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

//demo

export default ClinicProfileLandingPage;
